export { LegalPage as default } from '@/components/enpages/Legal'
